import type { ElementType } from "react";

import GoogleIcon from "shared/assets/svgs/google-icon.svg?react";

import { Button, type ButtonProps } from "./button";

export const GoogleButton = <E extends ElementType = "button">(
  props: ButtonProps<E>
) => {
  const { children } = props;
  return (
    <Button size="52" theme="secondary" {...props}>
      <GoogleIcon className="absolute top-1/2 left-4 size-7 -translate-y-1/2" />{" "}
      {children ?? "Sign in with Google"}
    </Button>
  );
};
